import { Helmet } from "react-helmet-async";
import AdminShell from "@/web/components/admin/admin-shell";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/web/components/ui/table";

export default function AdminCustomers() {
  return (
    <>
      <Helmet><title>Customers · Admin | Cool Wave</title></Helmet>
      <AdminShell>
        <div className="rounded-md border border-border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Orders</TableHead>
                <TableHead>Joined</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell colSpan={4} className="text-center text-sm text-body">No customers yet.</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </AdminShell>
    </>
  );
}
